import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import EmailCaptureModal from './EmailCaptureModal';
import { CONSULT_URL } from '../config/constants';
import * as FiIcons from 'react-icons/fi';

const { FiMonitor, FiLayout, FiZap, FiRefreshCw, FiUnlock, FiArrowRight } = FiIcons;

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n || 0);
const fmtN = (n) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(n || 0);

const Metric = ({ label, value, sub, color }) => (
  <div className="text-center">
    <div className="text-3xl font-bold" style={{ color }}>{value}</div>
    <div className="text-sm text-gray-500 mt-1">{label}</div>
    {sub && <div className="text-xs text-gray-400">{sub}</div>}
  </div>
);

const CombinedROIReport = ({ websiteResults, brandingResults, onRestart }) => {
  const [showModal, setShowModal] = useState(false);
  const totalInvestment = (websiteResults.investment || 0) + (brandingResults.investment || 0);
  const totalAnnual = (websiteResults.totalAnnualBenefits || 0) + (brandingResults.totalAnnualBenefits || 0) * 0.85 + (websiteResults.totalAnnualBenefits || 0) * 0.25;

  return (
    <div className="py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            <SafeIcon icon={FiZap} /> Combined ROI Report
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3"> Your Full Digital Impact Picture </h1>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="rounded-2xl p-8 text-white mb-6 shadow-xl" style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #7c3aed 50%, #a855f7 100%)' }} >
          <div className="text-center mb-6">
            <div className="text-xs font-bold uppercase tracking-widest opacity-70 mb-1">Combined Annual Benefit</div>
            <div className="text-5xl font-bold">{fmt(totalAnnual)}</div>
          </div>
          <div className="grid grid-cols-3 gap-4 border-t border-white/20 pt-6">
            <Metric label="Combined ROI" value={`${fmtN(totalInvestment > 0 ? (totalAnnual / totalInvestment) * 100 : 0)}%`} color="white" />
            <Metric label="Months to Payback" value={fmtN(totalAnnual > 0 ? totalInvestment / (totalAnnual / 12) : 0)} sub="months" color="white" />
            <Metric label="3-Year Net Value" value={fmt(totalAnnual * 3 - totalInvestment)} color="white" />
          </div>
        </motion.div>
        <motion.div className="grid md:grid-cols-2 gap-4">
          <button onClick={() => setShowModal(true)} className="py-4 rounded-2xl text-white font-bold shadow-lg hover:opacity-90 active:scale-95 transition-all flex items-center justify-center gap-2" style={{ background: 'linear-gradient(135deg, #3b82f6, #7c3aed)' }} >
            <SafeIcon icon={FiUnlock} /> Unlock Full Combined Report
          </button>
          <a href={CONSULT_URL} target="_blank" rel="noopener noreferrer" className="py-4 rounded-2xl font-bold border-2 border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-all flex items-center justify-center gap-2" >
            Book Free Strategy Call <SafeIcon icon={FiArrowRight} />
          </a>
        </motion.div>
        <div className="text-center mt-6">
          <button onClick={onRestart} className="text-gray-400 hover:text-gray-600 text-sm flex items-center gap-1 mx-auto transition-colors">
            <SafeIcon icon={FiRefreshCw} className="text-xs" /> Start over
          </button>
        </div>
      </div>
      <EmailCaptureModal isOpen={showModal} onClose={() => setShowModal(false)} onSubmit={() => { }} calculatorType="combined" previewData={{ totalAnnualBenefits: totalAnnual }} />
    </div>
  );
};

export default CombinedROIReport;